<template>
    <div class="page-header navbar navbar-fixed-top">
        <div class="page-header-inner ">
           	<span style="color:white;size:14px">
           		是否拥有权限 SCM_M60_FINISHED_GOODS_MASTER_DATA_SEARCH: {{auth.SCM_M60_FINISHED_GOODS_MASTER_DATA_SEARCH}}, 是否是管理员: {{isAdmin}},
           	</span>
        </div>
    </div>
</template>
<script>
export default {
	computed:{
		auth:function(){
			return this.$store.getters.auth;
		},

		isAdmin:function(){
			return this.$store.getters.isAdmin;
		}
	},
    methods: {}
}
</script>
